var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15749",
    "data-name": "Rectangle 15749",
    width: 14.394,
    height: 14.388,
    fill: "#292961"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40030",
    "data-name": "Group 40030",
    transform: "translate(-21 -353)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15750",
    "data-name": "Rectangle 15750",
    width: 18,
    height: 18,
    transform: "translate(21 353)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40029",
    "data-name": "Group 40029",
    transform: "translate(23 355)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40028",
    "data-name": "Group 40028",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82660",
    "data-name": "Path 82660",
    d: "M6.716,0H7.7c.082.011.164.026.246.034A.43.43,0,0,1,8.39.493c0,.065,0,.131.007.2A1.565,1.565,0,0,0,9.912,2.139a1.678,1.678,0,0,0,1.227-.5.4.4,0,0,1,.568-.054A6.9,6.9,0,0,1,12.84,2.735a.4.4,0,0,1-.015.516c-.042.05-.087.1-.132.146a1.584,1.584,0,0,0,.368,2.423,1.839,1.839,0,0,0,.774.225c.387.034.511.164.531.545a.876.876,0,0,0,.028.134v.984c-.013.091-.026.183-.038.274a.422.422,0,0,1-.471.412c-.07,0-.14.01-.21.014a1.592,1.592,0,0,0-1.426,1.472,1.628,1.628,0,0,0,.5,1.265.4.4,0,0,1,.04.591,7.2,7.2,0,0,1-1.118,1.1.413.413,0,0,1-.561-.013c-.049-.043-.1-.09-.146-.132a1.587,1.587,0,0,0-2.427.422,1.644,1.644,0,0,0-.2.779.435.435,0,0,1-.472.475c-.07,0-.14.018-.21.016-.435-.01-.87-.014-1.3-.04A.373.373,0,0,1,6,13.984c-.01-.093-.009-.187-.014-.281a1.568,1.568,0,0,0-1.511-1.44,1.677,1.677,0,0,0-1.228.5.4.4,0,0,1-.579.05,7.028,7.028,0,0,1-1.123-1.139.4.4,0,0,1,.012-.516c.042-.051.087-.1.132-.146a1.592,1.592,0,0,0-.168-2.29A1.671,1.671,0,0,0,.514,8.352a.449.449,0,0,1-.487-.44C.012,7.562,0,7.21,0,6.859a2.958,2.958,0,0,1,.047-.5A.371.371,0,0,1,.425,6.01c.144-.017.29-.022.432-.05a1.552,1.552,0,0,0,1.28-1.553,1.582,1.582,0,0,0-.5-1.152A.406.406,0,0,1,1.6,2.664a7.2,7.2,0,0,1,1.119-1.1.41.41,0,0,1,.561.017c.046.04.09.083.135.123a1.607,1.607,0,0,0,2.15-.039A1.571,1.571,0,0,0,6.047.544c.008-.355.155-.5.507-.515A1.254,1.254,0,0,0,6.716,0m2.7,10.7c-.018-.022-.034-.045-.053-.064q-.849-.851-1.7-1.7a.145.145,0,0,0-.185-.026,2.462,2.462,0,0,1-1.368.111A2.547,2.547,0,0,1,4.115,5.957c.031-.139.069-.264.223-.311s.247.046.342.14c.352.35.706.7,1.056,1.052a.307.307,0,0,0,.287.107c.24-.04.48-.077.721-.11a.175.175,0,0,0,.168-.171c.032-.227.063-.454.1-.679a.344.344,0,0,0-.108-.339c-.365-.357-.724-.721-1.081-1.086-.184-.189-.127-.455.117-.5a3.38,3.38,0,0,1,.764-.082A2.539,2.539,0,0,1,8.988,7.384a.176.176,0,0,0,.045.219c.547.54,1.089,1.085,1.633,1.629.028.028.059.052.09.079A4.144,4.144,0,1,0,9.411,10.7",
    transform: "translate(0)",
    fill: "#292961"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.ab712aad193d0cf6c251bc4c777988da.svg";
export { ForwardRef as ReactComponent };